export default __webpack_public_path__ + "static/media/information--end-of-minimum-speed-120--g1.57a848ce.png";